import React, { useState, useEffect } from 'react';

// Import your image files - update these paths as needed
import heroSlide1 from '../Images/residential1.jpg';
import heroSlide2 from '../Images/residential2.jpg';
import heroSlide3 from '../Images/residential3.jpg';
import project1 from '../Images/residential1.jpg';
import project2 from '../Images/residential2.jpg';
import project3 from '../Images/residential3.jpg';
import project4 from '../Images/residential4.jpg';
import project5 from '../Images/residential5.jpg';
import project6 from '../Images/residential6.jpg';

const Residential = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTab, setActiveTab] = useState('overview');
  // Add chatbot states
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
  const [leadStep, setLeadStep] = useState(0);
  const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
  const [messageCount, setMessageCount] = useState(0);
  const [quickReplies, setQuickReplies] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Initialize chat when opened
  useEffect(() => {
    if (isChatOpen && chatMessages.length === 0) {
      initChat();
    }
  }, [isChatOpen]);

  // Hero slideshow images - UPDATED WITH IMAGE PATHS
  const heroSlides = [
    {
      id: 1,
      title: "Power Your Home with Clean Energy",
      description: "Transform your rooftop into a power generation unit",
      image: heroSlide1
    },
    {
      id: 2,
      title: "Reduce Electricity Bills by 90%",
      description: "Generate your own electricity and save thousands monthly",
      image: heroSlide2
    },
    {
      id: 3,
      title: "Government Subsidies Available",
      description: "Get up to 40% subsidy on your solar installation",
      image: heroSlide3
    }
  ];

  // Project gallery images
  const galleryImages = [
    {
      id: 1,
      image: project1,
      title: "3kW System",
      location: "Nagpur, Maharashtra",
      description: "Residential Solar Installation 1"
    },
    {
      id: 2,
      image: project2,
      title: "5kW System",
      location: "Chandrapur, Maharashtra",
      description: "Residential Solar Installation 2"
    },
    {
      id: 3,
      image: project3,
      title: "10kW System",
      location: "Amravati, Maharashtra",
      description: "Residential Solar Installation 3"
    },
    {
      id: 4,
      image: project4,
      title: "3kW System",
      location: "Bhanadara, Maharashtra",
      description: "Residential Solar Installation 4"
    },
    {
      id: 5,
      image: project5,
      title: "5kW System",
      location: "Yavatmal, Maharashtra",
      description: "Residential Solar Installation 5"
    },
    {
      id: 6,
      image: project6,
      title: "10kW System",
      location: "Akola, Maharashtra",
      description: "Residential Solar Installation 6"
    }
  ];

  // Residential solar packages
  const solarPackages = [
    {
      name: "Basic Home",
      capacity: "3 kW",
      panels: "8",
      price: "₹1,50,000",
      savings: "₹2,500/month",
      features: [
        "8 Polycrystalline Panels",
        "3 kW Solar Inverter",
        "Basic Monitoring",
        "5-Year Warranty"
      ],
      bestFor: "2-3 BHK Homes"
    },
    {
      name: "Smart Home",
      capacity: "5 kW",
      panels: "14",
      price: "₹2,50,000",
      savings: "₹4,500/month",
      features: [
        "14 Monocrystalline Panels",
        "5 kW Hybrid Inverter",
        "Smart App Monitoring",
        "Net Metering Support",
        "10-Year Warranty"
      ],
      bestFor: "3-4 BHK Homes",
      popular: true
    },
    {
      name: "Premium Villa",
      capacity: "10 kW",
      panels: "28",
      price: "₹4,50,000",
      savings: "₹9,000/month",
      features: [
        "28 High-Efficiency Panels",
        "10 kW Hybrid Inverter",
        "Battery Backup Option",
        "24/7 Remote Monitoring",
        "25-Year Performance Warranty"
      ],
      bestFor: "Villas & Large Homes"
    }
  ];

  // Features and benefits
  const features = [
    {
      icon: "💰",
      title: "Save 90% on Bills",
      description: "Drastically reduce your monthly electricity expenses"
    },
    {
      icon: "⚡",
      title: "24/7 Power",
      description: "With battery backup, never face power cuts again"
    },
    {
      icon: "🌱",
      title: "Go Green",
      description: "Reduce carbon footprint and help the environment"
    },
    {
      icon: "📈",
      title: "Increase Property Value",
      description: "Solar homes have higher resale value"
    }
  ];

  // Installation process
  const installationSteps = [
    {
      step: "1",
      title: "Free Consultation",
      description: "Our expert visits your home for site assessment"
    },
    {
      step: "2",
      title: "Custom Design",
      description: "We create a 3D model of your solar system"
    },
    {
      step: "3",
      title: "Approvals & Subsidy",
      description: "We handle all paperwork and subsidy applications"
    },
    {
      step: "4",
      title: "Installation",
      description: "Professional installation in 2-3 days"
    },
    {
      step: "5",
      title: "Commissioning",
      description: "System testing and grid connection"
    },
    {
      step: "6",
      title: "Support",
      description: "25-year warranty and maintenance"
    }
  ];

  // Testimonials
  const testimonials = [
    {
      name: "Rajesh Sharma",
      location: "Nagpur",
      rating: 5,
      review: "Installed a 5kW system last year. My electricity bill went from ₹8,000 to ₹800! Best investment ever.",
      date: "6 months ago"
    },
    {
      name: "Priya Patel",
      location: "Amravati",
      rating: 5,
      review: "The installation was smooth and professional. The app lets me monitor energy generation in real-time.",
      date: "3 months ago"
    },
    {
      name: "Amit Kumar",
      location: "Chandrapur",
      rating: 5,
      review: "Got 40% subsidy through their assistance. The system pays for itself in just 4 years!",
      date: "1 year ago"
    }
  ];

  // FAQ
  const faqs = [
    {
      question: "How much space is needed for solar panels?",
      answer: "Approximately 100 sq ft per kW. A 3kW system needs about 300 sq ft of rooftop space."
    },
    {
      question: "What is the payback period?",
      answer: "Typically 3-5 years. After that, you get free electricity for 20+ years!"
    },
    {
      question: "Do I need battery backup?",
      answer: "Batteries are optional. Without batteries, you can use net metering to export excess power to the grid."
    },
    {
      question: "How much subsidy is available?",
      answer: "Up to 40% subsidy under government schemes. We help you get all eligible subsidies."
    },
    {
      question: "What maintenance is required?",
      answer: "Just occasional cleaning. We provide free maintenance for 5 years."
    }
  ];

  // Auto-rotate slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  // Chatbot functions
  const initChat = () => {
    addChatMessage("Hi 👋 Welcome to Blue Sky Energy! How can we help you with residential solar today?", 'bot');
    setTimeout(() => {
      addChatMessage("Choose an option to get started:", 'bot');
      setQuickReplies([
        "🏠 3kW Home Package", 
        "💰 Price & Subsidy", 
        "📋 Installation Process",
        "📍 Free Consultation"
      ]);
    }, 800);
  };

  const addChatMessage = (text, sender) => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newMessage = {
      text,
      sender,
      time,
      id: Date.now()
    };
    setChatMessages(prev => [...prev, newMessage]);
    if (sender === 'user') {
      setMessageCount(prev => prev + 1);
    }
  };

  // Keyword Logic for Residential
  const matchKeywords = (input) => {
    const text = input.toLowerCase();
    if (text.includes('human') || text.includes('call') || text.includes('talk')) {
      return "I'd be happy to connect you with our residential team! 📞\n\nCall us directly: +91 80879 32436\nOr chat on WhatsApp:\n👉 https://wa.me/918087932436";
    }
    if (text.includes('3kw') || text.includes('basic') || text.includes('home')) {
      return "🏠 3kW Home Package - ₹1,50,000\n\nPerfect for 2-3 BHK homes\n• Saves ₹2,500/month\n• 8 Polycrystalline Panels\n• 5-Year Warranty\n• Free Installation\n\nWant more details?";
    }
    if (text.includes('5kw') || text.includes('smart') || text.includes('popular')) {
      return "🏠 5kW Smart Home Package - ₹2,50,000\n\nMOST POPULAR for 3-4 BHK homes\n• Saves ₹4,500/month\n• 14 Monocrystalline Panels\n• Smart App Monitoring\n• 10-Year Warranty\n\nInterested in this package?";
    }
    if (text.includes('10kw') || text.includes('premium') || text.includes('villa')) {
      return "🏠 10kW Premium Villa Package - ₹4,50,000\n\nPerfect for villas & large homes\n• Saves ₹9,000/month\n• 28 High-Efficiency Panels\n• Battery Backup Option\n• 25-Year Warranty\n\nWant a custom quote?";
    }
    if (text.includes('price') || text.includes('cost') || text.includes('quote')) {
      return "💰 Residential Solar Pricing\n\n• 3kW: ₹1.5L (2-3 BHK)\n• 5kW: ₹2.5L (3-4 BHK)\n• 10kW: ₹4.5L (Villas)\n\nAll prices include installation, subsidies, and 5-year maintenance. Want a custom quote?";
    }
    if (text.includes('subsidy') || text.includes('government')) {
      return "🏛️ Government Subsidies\n\n• Up to 40% subsidy available\n• State & central government schemes\n• We handle all paperwork\n• Get subsidy in 15-30 days\n\nNeed subsidy assistance?";
    }
    if (text.includes('installation') || text.includes('process') || text.includes('step')) {
      return "🔧 Residential Installation Process\n\n1. Free home consultation\n2. Custom 3D design\n3. Subsidy & approvals\n4. 2-3 day installation\n5. Grid connection\n6. 25-year warranty\n\nWant to schedule a consultation?";
    }
    if (text.includes('space') || text.includes('rooftop')) {
      return "📏 Space Requirements\n\n• 3kW: 300 sq ft\n• 5kW: 500 sq ft\n• 10kW: 1000 sq ft\n\nWe can design systems for any rooftop shape. Want a free site visit?";
    }
    if (text.includes('savings') || text.includes('bill') || text.includes('save')) {
      return "💰 Average Monthly Savings\n\n• 3kW: ₹2,500/month\n• 5kW: ₹4,500/month\n• 10kW: ₹9,000/month\n\nPayback period: 3-5 years\nThen FREE electricity for 20+ years!\n\nWant to calculate your savings?";
    }
    return "I understand you're interested in residential solar! I can help with pricing, packages, subsidies, installation process, or connecting you with our home solar experts.";
  };

  // Lead Capture Logic
  const handleLeadCapture = (input) => {
    if (leadStep === 0) {
      setUserData(prev => ({ ...prev, name: input }));
      setLeadStep(1);
      addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number?`, 'bot');
    } else if (leadStep === 1) {
      setUserData(prev => ({ ...prev, phone: input }));
      setLeadStep(2);
      addChatMessage("Great! And which city are you from?", 'bot');
    } else if (leadStep === 2) {
      setUserData(prev => ({ ...prev, city: input }));
      setLeadCaptured(true);
      setAwaitingLeadInfo(false);
      saveLead({ ...userData, city: input });
      addChatMessage(`Perfect! Thank you ${userData.name}! ✅\n\nOur residential solar expert will contact you within 24 hours with a free consultation.`, 'bot');
    }
  };

  const saveLead = (data) => {
    const leadId = `lead_${Date.now()}`;
    localStorage.setItem(leadId, JSON.stringify({...data, timestamp: new Date()}));
    console.log("Residential Lead Saved:", data);
  };

  const handleChatSend = () => {
    const text = chatInput.trim();
    if (!text) return;

    addChatMessage(text, 'user');
    setChatInput('');
    setQuickReplies([]);

    setTimeout(() => {
      if (awaitingLeadInfo) {
        handleLeadCapture(text);
      } else {
        const response = matchKeywords(text);
        addChatMessage(response, 'bot');

        // Trigger Lead Capture after 2 interactions
        if (!leadCaptured && messageCount >= 1) {
          setTimeout(() => {
            addChatMessage("I'd love to help you with home solar! 📋\n\nCan I get your name to assist you better?", 'bot');
            setAwaitingLeadInfo(true);
          }, 1500);
        }
      }
    }, 600);
  };

  const handleQuickReply = (option) => {
    setChatInput(option);
    setTimeout(() => {
      handleChatSend();
    }, 100);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatSend();
    }
  };

  // State for hover effects
  const [hoverStates, setHoverStates] = useState({
    heroButton: false,
    packages: Array(solarPackages.length).fill(false),
    galleryItems: Array(galleryImages.length).fill(false),
    chatbotButton: false
  });

  // State for FAQ
  const [openFaq, setOpenFaq] = useState(null);

  const handleMouseEnter = (type, index) => {
    setHoverStates(prev => ({
      ...prev,
      [type]: Array.isArray(prev[type]) 
        ? prev[type].map((item, i) => i === index ? true : item)
        : true
    }));
  };

  const handleMouseLeave = (type, index) => {
    setHoverStates(prev => ({
      ...prev,
      [type]: Array.isArray(prev[type]) 
        ? prev[type].map((item, i) => i === index ? false : item)
        : false
    }));
  };

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // Responsive Styles
  const getResponsiveStyle = (desktopStyle, mobileStyle) => {
    return isMobile ? { ...desktopStyle, ...mobileStyle } : desktopStyle;
  };

  // Internal CSS with responsive adjustments - Blue Theme
  const styles = {
    container: {
      fontFamily: "Cambria, serif",
      color: "#123249",
      backgroundColor: "#ffffff",
      position: "relative",
      overflowX: "hidden",
      width: "100%"
    },
    
    // Chatbot Styles - Blue Theme
    chatbotContainer: {
      position: "fixed",
      bottom: isMobile ? "10px" : "20px",
      right: isMobile ? "10px" : "20px",
      zIndex: "9999",
      fontFamily: "Cambria, serif"
    },
    chatToggleBtn: {
      position: "fixed",
      bottom: isMobile ? "10px" : "20px",
      right: isMobile ? "10px" : "20px",
      width: isMobile ? "50px" : "60px",
      height: isMobile ? "50px" : "60px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      border: "none",
      fontSize: isMobile ? "20px" : "24px",
      cursor: "pointer",
      boxShadow: "0 8px 30px rgba(68, 119, 147, 0.3)",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "10000",
      padding: "0"
    },
    chatWindow: {
      position: "fixed",
      bottom: isMobile ? "70px" : "90px",
      right: isMobile ? "10px" : "20px",
      width: isMobile ? "calc(100vw - 20px)" : "380px",
      maxWidth: isMobile ? "calc(100vw - 20px)" : "calc(100vw - 40px)",
      height: isMobile ? "60vh" : "550px",
      maxHeight: isMobile ? "60vh" : "70vh",
      background: "white",
      borderRadius: "16px",
      boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      zIndex: "9999",
      transition: "all 0.3s ease",
      opacity: isChatOpen ? "1" : "0",
      visibility: isChatOpen ? "visible" : "hidden",
      transform: isChatOpen ? "translateY(0)" : "translateY(20px)",
      border: "1px solid #DDE8ED"
    },
    chatHeader: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      padding: isMobile ? "12px" : "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
    },
    headerInfo: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "8px" : "12px"
    },
    headerIcon: {
      background: "rgba(255, 255, 255, 0.2)",
      padding: isMobile ? "8px" : "10px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: isMobile ? "35px" : "40px",
      height: isMobile ? "35px" : "40px",
      fontSize: isMobile ? "16px" : "18px"
    },
    chatHeaderTitle: {
      margin: "0",
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "600",
      lineHeight: "1.2",
      color: "white"
    },
    chatHeaderSubtitle: {
      margin: "0",
      fontSize: isMobile ? "10px" : "12px",
      opacity: "0.9",
      lineHeight: "1.2",
      color: "#DDE8ED"
    },
    closeChatBtn: {
      background: "none",
      border: "none",
      color: "white",
      cursor: "pointer",
      fontSize: isMobile ? "16px" : "18px",
      padding: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "opacity 0.2s"
    },
    quickReplies: {
      padding: isMobile ? "8px" : "12px",
      display: "flex",
      flexWrap: "wrap",
      gap: isMobile ? "6px" : "8px",
      background: "#DDE8ED",
      borderBottom: "1px solid #DDE8ED",
      maxHeight: isMobile ? "80px" : "none",
      overflowY: "auto"
    },
    replyBtn: {
      background: "white",
      border: "1px solid #447793",
      color: "#123249",
      padding: isMobile ? "6px 12px" : "8px 16px",
      borderRadius: "20px",
      fontSize: isMobile ? "12px" : "13px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",
      fontWeight: "500",
      fontFamily: "Cambria, serif",
      flexShrink: "0"
    },
    chatMessages: {
      flex: "1",
      padding: isMobile ? "12px" : "16px",
      background: "#DDE8ED",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: isMobile ? "8px" : "12px"
    },
    message: {
      maxWidth: isMobile ? "90%" : "80%",
      padding: isMobile ? "10px 12px" : "12px 16px",
      borderRadius: "18px",
      fontSize: isMobile ? "13px" : "14px",
      lineHeight: "1.5",
      whiteSpace: "pre-line",
      wordWrap: "break-word",
      position: "relative",
      animation: "fadeIn 0.3s ease"
    },
    botMessage: {
      background: "white",
      alignSelf: "flex-start",
      borderBottomLeftRadius: "4px",
      boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
      color: "#123249",
      border: "1px solid #DDE8ED"
    },
    userMessage: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      alignSelf: "flex-end",
      borderBottomRightRadius: "4px"
    },
    messageTime: {
      fontSize: isMobile ? "10px" : "11px",
      marginTop: "6px",
      display: "block",
      opacity: "0.7"
    },
    chatInputArea: {
      padding: isMobile ? "12px" : "16px",
      borderTop: "1px solid #DDE8ED",
      background: "white"
    },
    inputWrapper: {
      display: "flex",
      gap: isMobile ? "8px" : "10px",
      marginBottom: isMobile ? "6px" : "8px"
    },
    chatInput: {
      flex: "1",
      padding: isMobile ? "10px 14px" : "12px 16px",
      border: "1px solid #DDE8ED",
      borderRadius: "25px",
      outline: "none",
      fontSize: isMobile ? "13px" : "14px",
      fontFamily: "Cambria, serif",
      transition: "border-color 0.2s",
      color: "#123249"
    },
    sendBtn: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      border: "none",
      width: isMobile ? "40px" : "45px",
      height: isMobile ? "40px" : "45px",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: isMobile ? "14px" : "16px",
      transition: "all 0.2s ease",
      padding: "0"
    },
    footerText: {
      textAlign: "center",
      fontSize: isMobile ? "10px" : "11px",
      color: "#2D5A74",
      margin: "0"
    },
    
    // Hero Section with Slideshow - Blue Theme
    heroSection: {
      position: "relative",
      height: isMobile ? "60vh" : "80vh",
      overflow: "hidden"
    },
    heroSlide: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "opacity 1s ease",
      opacity: 0,
      padding: isMobile ? "0 20px" : "0 5%",
      textAlign: "center",
      color: "white"
    },
    heroSlideActive: {
      opacity: 1,
      zIndex: 1
    },
    slideBackground: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      filter: "brightness(0.7)",
      zIndex: 0
    },
    darkOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(6, 18, 33, 0.5)",
      zIndex: 1
    },
    heroContent: {
      maxWidth: isMobile ? "100%" : "800px",
      zIndex: 2,
      position: "relative"
    },
    heroTitle: {
      fontSize: isMobile ? "2rem" : "3.5rem",
      fontWeight: "800",
      marginBottom: isMobile ? "15px" : "20px",
      textShadow: "2px 2px 4px rgba(6, 18, 33, 0.5)",
      lineHeight: isMobile ? "1.2" : "1.3",
      color: "white"
    },
    heroSubtitle: {
      fontSize: isMobile ? "1rem" : "1.5rem",
      marginBottom: isMobile ? "25px" : "40px",
      opacity: 0.9,
      lineHeight: "1.4",
      textShadow: "1px 1px 3px rgba(6, 18, 33, 0.5)",
      color: "#DDE8ED"
    },
    heroButton: {
      backgroundColor: "#447793",
      color: "white",
      padding: isMobile ? "12px 30px" : "15px 40px",
      fontSize: isMobile ? "1rem" : "1.2rem",
      fontWeight: "bold",
      border: "none",
      borderRadius: "50px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(6, 18, 33, 0.2)",
      position: "relative",
      zIndex: 2
    },
    heroButtonHover: {
      backgroundColor: "#2D5A74",
      transform: "scale(1.05)"
    },
    
    // Quick Stats - Blue Theme
    quickStats: {
      display: "flex",
      justifyContent: "center",
      gap: isMobile ? "20px" : "50px",
      padding: isMobile ? "30px 20px" : "40px 5%",
      backgroundColor: "#DDE8ED",
      flexWrap: "wrap"
    },
    statItem: {
      textAlign: "center",
      flex: isMobile ? "1 0 40%" : "none"
    },
    statNumber: {
      fontSize: isMobile ? "1.8rem" : "2.5rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: "5px"
    },
    statText: {
      fontSize: isMobile ? "0.9rem" : "1.1rem",
      color: "#2D5A74"
    },
    
    // Section Styles - Blue Theme
    section: {
      padding: isMobile ? "40px 20px" : "80px 5%",
      maxWidth: "1400px",
      margin: "0 auto"
    },
    sectionTitle: {
      fontSize: isMobile ? "2rem" : "2.8rem",
      fontWeight: "700",
      color: "#123249",
      textAlign: "center",
      marginBottom: isMobile ? "15px" : "20px",
      lineHeight: isMobile ? "1.2" : "1.3"
    },
    sectionSubtitle: {
      fontSize: isMobile ? "1rem" : "1.2rem",
      color: "#2D5A74",
      textAlign: "center",
      marginBottom: isMobile ? "40px" : "60px",
      maxWidth: isMobile ? "100%" : "800px",
      margin: isMobile ? "0 auto 40px" : "0 auto 60px",
      padding: isMobile ? "0 10px" : "0",
      lineHeight: "1.5"
    },
    
    // Packages Grid - Blue Theme
    packagesGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(350px, 1fr))",
      gap: isMobile ? "20px" : "30px",
      marginTop: isMobile ? "30px" : "50px"
    },
    packageCard: {
      backgroundColor: "white",
      borderRadius: isMobile ? "10px" : "15px",
      padding: isMobile ? "20px" : "30px",
      boxShadow: "0 10px 30px rgba(68, 119, 147, 0.1)",
      transition: "all 0.3s ease",
      position: "relative",
      border: "2px solid #DDE8ED"
    },
    packageCardHover: {
      transform: "translateY(-10px)",
      boxShadow: "0 20px 40px rgba(68, 119, 147, 0.15)"
    },
    popularBadge: {
      position: "absolute",
      top: isMobile ? "-12px" : "-15px",
      right: isMobile ? "20px" : "30px",
      backgroundColor: "#447793",
      color: "white",
      padding: isMobile ? "6px 15px" : "8px 20px",
      borderRadius: "25px",
      fontWeight: "bold",
      fontSize: isMobile ? "0.8rem" : "0.9rem"
    },
    packageHeader: {
      textAlign: "center",
      marginBottom: isMobile ? "20px" : "30px"
    },
    packageName: {
      fontSize: isMobile ? "1.5rem" : "1.8rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: isMobile ? "8px" : "10px"
    },
    packageCapacity: {
      fontSize: isMobile ? "1.8rem" : "2.2rem",
      fontWeight: "800",
      color: "#447793",
      marginBottom: isMobile ? "8px" : "10px"
    },
    packagePrice: {
      fontSize: isMobile ? "1.5rem" : "1.8rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: isMobile ? "5px" : "5px"
    },
    packageSavings: {
      fontSize: isMobile ? "1rem" : "1.1rem",
      color: "#2D5A74",
      fontWeight: "600"
    },
    packageFeatures: {
      listStyle: "none",
      padding: "0",
      marginBottom: isMobile ? "20px" : "30px"
    },
    packageFeature: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "8px" : "10px",
      marginBottom: isMobile ? "10px" : "12px",
      color: "#2D5A74",
      fontSize: isMobile ? "0.95rem" : "1rem"
    },
    featureIcon: {
      color: "#447793",
      fontSize: isMobile ? "1rem" : "1.2rem"
    },
    packageBestFor: {
      textAlign: "center",
      color: "#2D5A74",
      fontStyle: "italic",
      marginTop: isMobile ? "15px" : "20px",
      paddingTop: isMobile ? "15px" : "20px",
      borderTop: "1px solid #DDE8ED",
      fontSize: isMobile ? "0.9rem" : "1rem"
    },
    
    // Features Grid - Blue Theme
    featuresGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))",
      gap: isMobile ? "20px" : "30px",
      marginTop: isMobile ? "30px" : "50px"
    },
    featureCard: {
      backgroundColor: "#DDE8ED",
      borderRadius: isMobile ? "8px" : "10px",
      padding: isMobile ? "20px" : "30px",
      textAlign: "center",
      transition: "all 0.3s ease"
    },
    featureIconLarge: {
      fontSize: isMobile ? "2.5rem" : "3rem",
      marginBottom: isMobile ? "15px" : "20px"
    },
    featureTitle: {
      fontSize: isMobile ? "1.2rem" : "1.4rem",
      fontWeight: "600",
      color: "#123249",
      marginBottom: isMobile ? "8px" : "10px"
    },
    featureDescription: {
      fontSize: isMobile ? "0.95rem" : "1rem",
      color: "#2D5A74",
      lineHeight: "1.5"
    },
    
    // Installation Timeline - Blue Theme
    timelineContainer: {
      position: "relative",
      marginTop: isMobile ? "30px" : "50px",
      paddingLeft: isMobile ? "40px" : "50px"
    },
    timelineLine: {
      position: "absolute",
      left: isMobile ? "20px" : "25px",
      top: "0",
      bottom: "0",
      width: "2px",
      backgroundColor: "#447793",
      opacity: "0.3"
    },
    timelineStep: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: isMobile ? "30px" : "40px",
      position: "relative"
    },
    timelineDot: {
      width: isMobile ? "40px" : "50px",
      height: isMobile ? "40px" : "50px",
      backgroundColor: "#447793",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "bold",
      fontSize: isMobile ? "1rem" : "1.2rem",
      position: "absolute",
      left: isMobile ? "-46px" : "-56px"
    },
    timelineContent: {
      backgroundColor: "#DDE8ED",
      padding: isMobile ? "20px" : "25px",
      borderRadius: isMobile ? "8px" : "10px",
      borderLeft: "5px solid #447793",
      flex: "1"
    },
    timelineTitle: {
      fontSize: isMobile ? "1.2rem" : "1.4rem",
      fontWeight: "600",
      color: "#123249",
      marginBottom: isMobile ? "8px" : "10px"
    },
    timelineDescription: {
      fontSize: isMobile ? "0.95rem" : "1rem",
      color: "#2D5A74",
      lineHeight: "1.5"
    },
    
    // Testimonials Carousel - Blue Theme
    testimonialsContainer: {
      display: "flex",
      overflowX: "auto",
      gap: isMobile ? "20px" : "30px",
      padding: isMobile ? "20px 0" : "30px 0",
      marginTop: isMobile ? "30px" : "50px",
      scrollbarWidth: "thin",
      paddingLeft: isMobile ? "20px" : "0",
      paddingRight: isMobile ? "20px" : "0",
      scrollSnapType: isMobile ? "x mandatory" : "none"
    },
    testimonialCard: {
      minWidth: isMobile ? "85vw" : "350px",
      backgroundColor: "white",
      borderRadius: isMobile ? "10px" : "15px",
      padding: isMobile ? "20px" : "30px",
      boxShadow: "0 5px 20px rgba(6, 18, 33, 0.05)",
      border: "1px solid #DDE8ED",
      scrollSnapAlign: isMobile ? "start" : "none"
    },
    testimonialRating: {
      color: "#447793",
      fontSize: isMobile ? "1.3rem" : "1.5rem",
      marginBottom: isMobile ? "15px" : "20px"
    },
    testimonialReview: {
      fontSize: isMobile ? "1rem" : "1.1rem",
      color: "#2D5A74",
      lineHeight: "1.6",
      marginBottom: isMobile ? "15px" : "20px",
      fontStyle: "italic"
    },
    testimonialAuthor: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: isMobile ? "wrap" : "nowrap"
    },
    authorInfo: {
      display: "flex",
      flexDirection: "column",
      marginBottom: isMobile ? "10px" : "0"
    },
    authorName: {
      fontWeight: "600",
      color: "#123249",
      fontSize: isMobile ? "1rem" : "1.1rem"
    },
    authorLocation: {
      color: "#2D5A74",
      fontSize: isMobile ? "0.85rem" : "0.9rem"
    },
    
    // FAQ Section - Blue Theme
    faqContainer: {
      maxWidth: "800px",
      margin: isMobile ? "30px auto 0" : "50px auto 0"
    },
    faqItem: {
      marginBottom: isMobile ? "15px" : "20px",
      border: "1px solid #DDE8ED",
      borderRadius: isMobile ? "8px" : "10px",
      overflow: "hidden"
    },
    faqQuestion: {
      padding: isMobile ? "15px" : "20px",
      backgroundColor: "#DDE8ED",
      fontSize: isMobile ? "1.1rem" : "1.2rem",
      fontWeight: "600",
      color: "#123249",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    faqAnswer: {
      padding: isMobile ? "15px" : "20px",
      backgroundColor: "white",
      color: "#2D5A74",
      lineHeight: "1.6",
      fontSize: isMobile ? "0.95rem" : "1rem"
    },
    
    // CTA Section - Blue Theme
    ctaSection: {
      backgroundColor: "#123249",
      color: "white",
      padding: isMobile ? "40px 20px" : "80px 5%",
      textAlign: "center",
      borderRadius: isMobile ? "10px" : "15px",
      margin: isMobile ? "40px 20px" : "80px 5%"
    },
    ctaTitle: {
      fontSize: isMobile ? "1.8rem" : "2.5rem",
      fontWeight: "700",
      marginBottom: isMobile ? "15px" : "20px",
      lineHeight: isMobile ? "1.2" : "1.3",
      color: "white"
    },
    ctaDescription: {
      fontSize: isMobile ? "1rem" : "1.3rem",
      opacity: "0.9",
      maxWidth: isMobile ? "100%" : "800px",
      margin: isMobile ? "0 auto 20px" : "0 auto",
      lineHeight: "1.5",
      padding: isMobile ? "0" : "0",
      color: "#DDE8ED"
    },
    ctaButton: {
      backgroundColor: "#447793",
      color: "white",
      padding: isMobile ? "15px 35px" : "18px 50px",
      fontSize: isMobile ? "1.1rem" : "1.3rem",
      fontWeight: "bold",
      border: "none",
      borderRadius: "50px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      marginTop: isMobile ? "20px" : "30px"
    },
    ctaPhone: {
      marginTop: isMobile ? "20px" : "30px",
      fontSize: isMobile ? "1rem" : "1.1rem",
      opacity: "0.8",
      color: "#DDE8ED"
    },
    
    // Image Gallery - Blue Theme
    imageGallery: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: isMobile ? "15px" : "20px",
      marginTop: isMobile ? "30px" : "50px"
    },
    galleryItem: {
      position: "relative",
      height: isMobile ? "250px" : "300px",
      borderRadius: isMobile ? "8px" : "10px",
      overflow: "hidden",
      cursor: "pointer"
    },
    galleryImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.3s ease"
    },
    galleryOverlay: {
      position: "absolute",
      bottom: "0",
      left: "0",
      right: "0",
      background: "linear-gradient(transparent, rgba(18, 50, 73, 0.9))",
      color: "white",
      padding: isMobile ? "15px" : "20px",
      transform: "translateY(100%)",
      transition: "transform 0.3s ease",
      fontSize: isMobile ? "0.9rem" : "1rem"
    },
    galleryTitle: {
      fontWeight: "600",
      marginBottom: "5px",
      fontSize: isMobile ? "1rem" : "1.1rem",
      color: "white"
    },
    galleryLocation: {
      opacity: "0.8",
      fontSize: isMobile ? "0.85rem" : "0.9rem",
      color: "#DDE8ED"
    },
    
    // Mobile-specific styles
    mobileHidden: {
      display: isMobile ? "none" : "block"
    },
    mobileOnly: {
      display: isMobile ? "block" : "none"
    }
  };

  return (
    <div style={styles.container}>
      {/* Hero Section with Slideshow - Blue Theme */}
      <section style={styles.heroSection}>
        {heroSlides.map((slide, index) => (
          <div 
            key={slide.id}
            style={{
              ...styles.heroSlide,
              ...(index === currentSlide ? styles.heroSlideActive : {})
            }}
          >
            {/* Background Image */}
            <div 
              style={{
                ...styles.slideBackground,
                backgroundImage: `url(${slide.image})`
              }} 
            />
            
            {/* Dark Overlay */}
            <div style={styles.darkOverlay} />
            
            <div style={styles.heroContent}>
              <h1 style={styles.heroTitle}>{slide.title}</h1>
              <p style={styles.heroSubtitle}>{slide.description}</p>
              <button 
                style={{
                  ...styles.heroButton,
                  ...(hoverStates.heroButton ? styles.heroButtonHover : {})
                }}
                onMouseEnter={() => handleMouseEnter('heroButton')}
                onMouseLeave={() => handleMouseLeave('heroButton')}
              >
                Get Free Consultation
              </button>
            </div>
          </div>
        ))}
        
        {/* Slide Indicators */}
        <div style={{
          position: "absolute",
          bottom: isMobile ? "20px" : "30px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: isMobile ? "8px" : "10px",
          zIndex: "3"
        }}>
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              style={{
                width: isMobile ? "10px" : "12px",
                height: isMobile ? "10px" : "12px",
                borderRadius: "50%",
                backgroundColor: index === currentSlide ? "#447793" : "rgba(255,255,255,0.5)",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
            />
          ))}
        </div>
      </section>

      {/* Quick Stats - Blue Theme */}
      <div style={styles.quickStats}>
        <div style={styles.statItem}>
          <div style={styles.statNumber}>4500+</div>
          <div style={styles.statText}>Homes Powered</div>
        </div>
        <div style={styles.statItem}>
          <div style={styles.statNumber}>90%</div>
          <div style={styles.statText}>Average Bill Savings</div>
        </div>
        <div style={styles.statItem}>
          <div style={styles.statNumber}>40%</div>
          <div style={styles.statText}>Government Subsidy</div>
        </div>
        <div style={styles.statItem}>
          <div style={styles.statNumber}>25 Years</div>
          <div style={styles.statText}>System Warranty</div>
        </div>
      </div>

      {/* Solar Packages - Blue Theme */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Residential Solar Packages</h2>
        <p style={styles.sectionSubtitle}>
          Choose the perfect solar solution for your home. All packages include installation, subsidies, and maintenance.
        </p>

        <div style={styles.packagesGrid}>
          {solarPackages.map((pkg, index) => (
            <div 
              key={index}
              style={{
                ...styles.packageCard,
                ...(hoverStates.packages[index] ? styles.packageCardHover : {})
              }}
              onMouseEnter={() => handleMouseEnter('packages', index)}
              onMouseLeave={() => handleMouseLeave('packages', index)}
            >
              {pkg.popular && (
                <div style={styles.popularBadge}>MOST POPULAR</div>
              )}
              
              <div style={styles.packageHeader}>
                <h3 style={styles.packageName}>{pkg.name}</h3>
                <div style={styles.packageCapacity}>{pkg.capacity}</div>
                <div style={styles.packagePrice}>{pkg.price}</div>
                <div style={styles.packageSavings}>Saves {pkg.savings}</div>
              </div>
              
              <ul style={styles.packageFeatures}>
                {pkg.features.map((feature, featureIndex) => (
                  <li key={featureIndex} style={styles.packageFeature}>
                    <span style={styles.featureIcon}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <div style={styles.packageBestFor}>
                Best for: {pkg.bestFor}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Features & Benefits - Blue Theme */}
      <section style={{...styles.section, backgroundColor: "#DDE8ED"}}>
        <h2 style={styles.sectionTitle}>Why Choose Solar for Your Home?</h2>
        <p style={styles.sectionSubtitle}>
          Discover the multiple benefits of switching to solar power for your residence
        </p>

        <div style={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} style={styles.featureCard}>
              <div style={styles.featureIconLarge}>{feature.icon}</div>
              <h3 style={styles.featureTitle}>{feature.title}</h3>
              <p style={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Installation Process - Blue Theme */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Simple 6-Step Installation</h2>
        <p style={styles.sectionSubtitle}>
          From consultation to commissioning, we make solar installation hassle-free
        </p>

        <div style={styles.timelineContainer}>
          <div style={styles.timelineLine}></div>
          
          {installationSteps.map((step, index) => (
            <div key={index} style={styles.timelineStep}>
              <div style={styles.timelineDot}>{step.step}</div>
              <div style={styles.timelineContent}>
                <h3 style={styles.timelineTitle}>{step.title}</h3>
                <p style={styles.timelineDescription}>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Customer Testimonials - Blue Theme */}
      <section style={{...styles.section, backgroundColor: "#DDE8ED"}}>
        <h2 style={styles.sectionTitle}>What Our Customers Say</h2>
        <p style={styles.sectionSubtitle}>
          Hear from homeowners who have made the switch to solar
        </p>

        <div style={styles.testimonialsContainer}>
          {testimonials.map((testimonial, index) => (
            <div key={index} style={styles.testimonialCard}>
              <div style={styles.testimonialRating}>
                {"★".repeat(testimonial.rating)}
              </div>
              <p style={styles.testimonialReview}>"{testimonial.review}"</p>
              <div style={styles.testimonialAuthor}>
                <div style={styles.authorInfo}>
                  <div style={styles.authorName}>{testimonial.name}</div>
                  <div style={styles.authorLocation}>{testimonial.location}</div>
                </div>
                <div style={{color: "#2D5A74", fontSize: isMobile ? "0.85rem" : "0.9rem"}}>
                  {testimonial.date}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section - Blue Theme */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Frequently Asked Questions</h2>
        <p style={styles.sectionSubtitle}>
          Get answers to common questions about residential solar
        </p>

        <div style={styles.faqContainer}>
          {faqs.map((faq, index) => (
            <div key={index} style={styles.faqItem}>
              <div 
                style={styles.faqQuestion}
                onClick={() => toggleFaq(index)}
              >
                <span>{faq.question}</span>
                <span>{openFaq === index ? "−" : "+"}</span>
              </div>
              {openFaq === index && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Image Gallery - Blue Theme */}
      <section style={{...styles.section, paddingTop: "0"}}>
        <h2 style={styles.sectionTitle}>Our Residential Projects</h2>
        <p style={styles.sectionSubtitle}>
          See some of our successful residential solar installations across India
        </p>
        
        <div style={styles.imageGallery}>
          {galleryImages.map((item, index) => (
            <div 
              key={item.id}
              style={styles.galleryItem}
              onMouseEnter={() => handleMouseEnter('galleryItems', index)}
              onMouseLeave={() => handleMouseLeave('galleryItems', index)}
            >
              {/* Image */}
              <img 
                src={item.image} 
                alt={item.description}
                style={{
                  ...styles.galleryImage,
                  transform: hoverStates.galleryItems[index] ? "scale(1.05)" : "scale(1)"
                }}
              />
              
              {/* Overlay */}
              <div style={{
                ...styles.galleryOverlay,
                transform: hoverStates.galleryItems[index] ? "translateY(0)" : "translateY(100%)"
              }}>
                <div style={styles.galleryTitle}>{item.title}</div>
                <div style={styles.galleryLocation}>{item.location}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA - Blue Theme */}
      <section style={styles.ctaSection}>
        <h2 style={styles.ctaTitle}>Ready to Power Your Home with Solar?</h2>
        <p style={styles.ctaDescription}>
          Get a free site assessment and customized solar proposal for your home. 
          Our experts will calculate your savings and guide you through the entire process.
        </p>
        <button 
          style={styles.ctaButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#2D5A74';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#447793';
            e.target.style.transform = 'none';
          }}
        >
          Book Free Site Visit
        </button>
        <div style={styles.ctaPhone}>
          Or call us at: <strong style={{color: "#DDE8ED"}}>+91 80879 32436</strong>
        </div>
      </section>

      {/* Chatbot Component - Blue Theme */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          
          /* Mobile responsiveness fixes */
          @media (max-width: 768px) {
            .testimonial-card {
              min-width: 85vw;
            }
            
            .stat-item {
              flex: 1 0 40%;
              margin-bottom: 15px;
            }
            
            .package-card {
              margin: 0 10px;
            }
            
            .hero-title {
              font-size: 2rem;
              padding: 0 10px;
            }
            
            .hero-subtitle {
              font-size: 1rem;
              padding: 0 20px;
            }
          }
          
          @media (max-width: 480px) {
            .hero-title {
              font-size: 1.8rem;
            }
            
            .section-title {
              font-size: 1.8rem;
            }
            
            .stat-number {
              font-size: 1.6rem;
            }
            
            .stat-text {
              font-size: 0.85rem;
            }
            
            .quick-stats {
              gap: 15px;
            }
          }
          
          /* Custom scrollbar for chat */
          ::-webkit-scrollbar {
            width: 6px;
          }
          
          ::-webkit-scrollbar-track {
            background: #DDE8ED;
          }
          
          ::-webkit-scrollbar-thumb {
            background: #447793;
            border-radius: 3px;
          }
          
          ::-webkit-scrollbar-thumb:hover {
            background: #2D5A74;
          }
          
          /* Prevent text selection on mobile */
          * {
            -webkit-tap-highlight-color: transparent;
          }
          
          /* Hover effects */
          .package-card:hover {
            transform: translateY(-10px) !important;
            box-shadow: 0 20px 40px rgba(68, 119, 147, 0.15) !important;
          }
          
          .cta-button:hover {
            background-color: #2D5A74 !important;
            transform: translateY(-2px) !important;
          }
          
          .hero-button:hover {
            background-color: #2D5A74 !important;
            transform: scale(1.05) !important;
          }
        `}
      </style>

      <div style={styles.chatbotContainer}>
        {/* Chat Toggle Button */}
        <button 
          style={{
            ...styles.chatToggleBtn,
            animation: hoverStates.chatbotButton ? "pulse 0.5s infinite" : "pulse 2s infinite"
          }}
          onClick={() => setIsChatOpen(!isChatOpen)}
          onMouseEnter={() => handleMouseEnter('chatbotButton')}
          onMouseLeave={() => handleMouseLeave('chatbotButton')}
        >
          💬
        </button>

        {/* Chat Window */}
        <div style={styles.chatWindow}>
          {/* Chat Header */}
          <div style={styles.chatHeader}>
            <div style={styles.headerInfo}>
              <div style={styles.headerIcon}>
                🏠
              </div>
              <div>
                <h3 style={styles.chatHeaderTitle}>Blue Sky Energy</h3>
                <p style={styles.chatHeaderSubtitle}>Residential Solar Experts</p>
              </div>
            </div>
            <button 
              style={styles.closeChatBtn}
              onClick={() => setIsChatOpen(false)}
            >
              ✕
            </button>
          </div>

          {/* Quick Replies */}
          {quickReplies.length > 0 && (
            <div style={styles.quickReplies}>
              {quickReplies.map((option, index) => (
                <button
                  key={index}
                  style={styles.replyBtn}
                  onClick={() => handleQuickReply(option)}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#447793';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = '#123249';
                    e.target.style.transform = 'none';
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          {/* Chat Messages */}
          <div style={styles.chatMessages}>
            {chatMessages.map((msg) => (
              <div 
                key={msg.id} 
                style={{
                  ...styles.message,
                  ...(msg.sender === 'bot' ? styles.botMessage : styles.userMessage)
                }}
              >
                {msg.text}
                <span style={styles.messageTime}>{msg.time}</span>
              </div>
            ))}
          </div>

          {/* Chat Input */}
          <div style={styles.chatInputArea}>
            <div style={styles.inputWrapper}>
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Type your message..."
                style={styles.chatInput}
                onFocus={(e) => e.target.style.borderColor = '#447793'}
                onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
              />
              <button 
                style={styles.sendBtn}
                onClick={handleChatSend}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #2D5A74, #123249)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #447793, #2D5A74)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                📤
              </button>
            </div>
            <p style={styles.footerText}>Powered by Blue Sky Energy</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Residential;